import { z } from "zod";

/**
 * VerbaPagamentoSchema
 */

export const VerbaPagamentoSchema = z.object({
  ativo: z.coerce.boolean(),
  tipo: z.coerce.number(),
  nro: z.string().nullable().default(null),
  verba: z.string(),
  valor: z.number().nullable().default(null),
});

/**
 * VerbaPagamentoForm
 */

export type VerbaPagamentoForm = z.infer<typeof VerbaPagamentoSchema>;

/**
 * defaultVerbaPagamentoFormValues
 */

export const defaultVerbaPagamentoFormValues: Partial<VerbaPagamentoForm> = {
  ativo: true,
  tipo: 0,
};